import { Box, Dialog, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import Button from 'newComponents/Button';
import React from 'react';

const DialogAlert = ( { isOpen, title, subTitle, children, closeFunction } ) => {
	return (
		<Dialog
			open={isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			style={{ zIndex: 9999 }}
		>
			<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					{subTitle}
				</DialogContentText>
				{children}
			</DialogContent>
			<Box display={'flex'} justifyContent={'center'} alignItems={'center'} padding={'8px'}>
				<Button onClick={closeFunction}>Entendi</Button>
			</Box>
		</Dialog>
	);
};

export default DialogAlert;